document.addEventListener('DOMContentLoaded' , () =>{
    // tab    
    const tabModule = document.querySelectorAll('.js-tabModule');

    class tab {
        constructor(target) {
            this.target = target;
            this.tabBtnArray = Array.from(this.target.querySelectorAll('.tab__btn')).filter(
                el => el.closest('.js-tabModule') === this.target
            );
            this.tabConArray = Array.from(this.target.querySelectorAll('.tab__content')).filter(
                el => el.closest('.js-tabModule') === this.target
            );
        }
    
        tabFn() {
            const _this = this;
            
            this.tabBtnArray.forEach(function(el,index){
                if(!el) return;

                el.addEventListener("click" , function(){                                                     
                    _this.tabBtnArray.forEach(function(el){
                        el.parentNode.classList.remove("on");
                    });                    

                    _this.tabBtnArray[index].parentNode.classList.add("on");         

                    _this.tabConArray.forEach(function(el){
                        el.classList.remove("on");
                    })

                    if (_this.tabConArray[index]) {
                        _this.tabConArray[index].classList.add("on");
                    }
                })
            })
        }
    }    
    tabModule.forEach(el => {        
        new tab(el).tabFn();
    });
});
